import { render, staticRenderFns } from "./NewJurisdiction.vue?vue&type=template&id=4e0a8ed6"
import script from "./NewJurisdiction.vue?vue&type=script&lang=js"
export * from "./NewJurisdiction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports